import template from './sw-cms-block-text-teaser-section.html.twig';
import './sw-cms-block-text-teaser-section.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
